import React from 'react';
import { motion } from 'framer-motion';
import './CustomerLogos.css';

// Import customer logos
import bungeLogo from '../../images/customerLogo/Bunge_Limited-Logo.wine.png';
import images2 from '../../images/customerLogo/images 2.jpeg';
import images1 from '../../images/customerLogo/images.jpeg';
import imagesPng from '../../images/customerLogo/images.png';
import maxresdefault from '../../images/customerLogo/maxresdefault.jpg';
import mumbaiRefinery from '../../images/customerLogo/mumbai-refinery-oil-refinery-bharat-petroleum-office-logo-png-favpng-PiFS3SHxZMspW5HwvLyJqmQeC.jpg';
import otsukaLogo from '../../images/customerLogo/Otsuka_Holdings_logo.svg.png';
import newLogo from '../../images/customerLogo/png-clipart-abu-dhabi-national-oil-company-ruwais-oil-refinery-petroleum-others-miscellaneous-company.png';

const CustomerLogos = () => {
  const customerLogos = [
    { src: bungeLogo, alt: 'Bunge Limited' },
    { src: images2, alt: 'Customer Logo 2' },
    { src: images1, alt: 'Customer Logo 1' },
    { src: imagesPng, alt: 'Customer Logo PNG' },
    { src: maxresdefault, alt: 'Customer Logo' },
    { src: mumbaiRefinery, alt: 'Mumbai Refinery' },
    { src: otsukaLogo, alt: 'Otsuka Holdings' },
    { src: newLogo, alt: 'Additional Refinery' },
  ];

  // Duplicate the logos array to create seamless scrolling
  const duplicatedLogos = [...customerLogos, ...customerLogos];

  return (
    <div className="customer-logos-container">
      <div className="customer-logos-track">
        <motion.div
          className="customer-logos-content"
          animate={{
            x: [0, -140 * customerLogos.length], // Move left by the width of all logos
          }}
          transition={{
            duration: 20, // 20 seconds for one complete cycle
            repeat: Infinity,
            ease: "linear",
          }}
        >
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="customer-logo-item">
              <img
                src={logo.src}
                alt={logo.alt}
                className="customer-logo-img"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default CustomerLogos;
